/** 解析倒计时目标时间（毫秒），无效或空则返回 null */
export function parseCountdownTargetMs(
  date: Date | string | number | null | undefined,
): number | null {
  if (date == null || date === '') return null;
  const t = new Date(date).getTime();
  return Number.isNaN(t) ? null : t;
}

/**
 * 是否应运行实时倒计时：目标时间有效且仍在未来。
 * 未设置、无效或已到期（当前时间不早于目标）时返回 false，展示静态 0。
 */
export function isCountdownActive(
  date: Date | string | number | null | undefined,
  now = Date.now(),
): boolean {
  const target = parseCountdownTargetMs(date);
  if (target == null) return false;
  return target > now;
}
